module.exports = __webpack_public_path__ + "img/icon_cs_feature_jobfair.c5429158.png";